import { useMemo } from "react";
import { useLocation } from "react-router";

function useQuery(): any {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

export default useQuery;